/**
 * Created by Kirill Mashchenko on 24.04.20.
 */

var FunctionButtonK = FunctionButton.extend(/** @lends FunctionButtonK#*/{

	selected: false,
	_isNative: true,

	ctor: function(type, value, isNative)
	{
		this._value = value;
		if(isNative !== undefined)
			this._isNative = isNative;
		this._super(type);
		pm.registerCustomEventListener(pm.DESELECT_FUNCTIONBUTTON, function (event)
		{
			this.stopAnimation();
			this.selected = false;
		}.bind(this), this);
	},

	isNativeMethod: function ()
	{
		return this._isNative;
	},

	getValue: function()
	{
		return this._value;
	},

	setValue: function(value)
	{
		this._value = value;
		this._valueChanged();
	},

	getType: function()
	{
		return this._type;
	},

	setType: function(type, value)
	{
		if (this._type === FunctionButton.Type.CondRepeater)
		{
			this.removeChildByTag(FunctionButton.BACKGROUND_SPRITE_TAG);
			this.getVirtualRenderer().setScale(1.0);
		}

		this._type = type;

		if (value === undefined)
			this.setValue(this._value);
		else
			this.setValue(value);

		if (this._type === FunctionButton.Type.CondRepeater)
		{
			var sprite = pm.spriteUtils.getRepeaterSprite("cond");
			sprite.setPosition(0, this.height);
			sprite.setAnchorPoint(cc.p(0, 1));

			this.addChild(sprite, -1, FunctionButton.BACKGROUND_SPRITE_TAG);

			this.getVirtualRenderer().setScale(FunctionButton.COND_REPEATER_SCALE);
		}

		if(this._backSprite)
		{
			this._backSprite.removeFromParent();
			this._backSprite = null;
		}

		if (this._drawBackground)
		{
			this._backSprite = this._getBackgroundSprite();

			if (this._backSprite !== "")
			{
				this._backSprite.setPosition(cc.p(0, this.height));
				this._backSprite.setAnchorPoint(cc.p(0, 1));
				this.addChild(this._backSprite, -2);
			}
		}
	},

	/**
	 * Clones button normal image.
	 * @returns {ccui.ImageView}
	 */
	cloneImage: function()
	{
		return pm.appUtils.generateFunctionButton(this._type, this._value);
	},

	clone: function()
	{
		return pm.appUtils.generateFunctionButton(this._type, this._value);
	},

	/**
	 * Selects function button and writes to {@link FunctionButton.selectedButton}
	 */
	select: function()
	{
		if(this.selected)
		{
			this.stopAnimation();
			this.selected = false;
		}
		else
		{
			pm.sendCustomEvent(pm.DESELECT_FUNCTIONBUTTON);
			FunctionButton.selectedButton = this.clone();
			this.selected = true;
			this.startAnimation();
		}
	},

	_valueChanged: function()
	{
		this.loadTextureNormal(this._getSpriteName(pm.NORMAL_STATE), ccui.Widget.PLIST_TEXTURE);
		this.loadTexturePressed(this._getSpriteName(pm.SELECTED_STATE), ccui.Widget.PLIST_TEXTURE);
		this.loadTextureDisabled(this._getSpriteName(pm.DISABLED_STATE), ccui.Widget.PLIST_TEXTURE);
	},

	_getSpriteName: function(state)
	{
		switch (this._type)
		{
			case FunctionButton.Type.Constant:
				return pm.spriteUtils.getRepeaterSpriteName(this._value % 7, state);
			case FunctionButton.Type.Repeater:
				return pm.spriteUtils.getRepeaterSpriteName(this._value, state);
			case FunctionButton.Type.Condition:
			case FunctionButton.Type.LogicExpression:
			case FunctionButton.Type.AndOrExpression:
			case FunctionButton.Type.NotExpression:
			case FunctionButton.Type.CondRepeater:
				return pm.spriteUtils.getRobotConditionSpriteName(this._value, state);
			case FunctionButton.Type.Alloc:
				return pm.spriteUtils.getAllocSpriteName(this._value, state);
			case FunctionButton.Type.IntMethod:
				return pm.spriteUtils.getIntMethodSpriteName(this._value, state);
			case FunctionButton.Type.Method:
			case FunctionButton.Type.Function:
				return pm.spriteUtils.getRobotMethodSpriteName(this._value, state);
			case FunctionButton.Type.Empty:
				return pm.spriteUtils.getEmptyMethodSpriteName(state);
			case FunctionButton.Type.IfStatement:
			case FunctionButton.Type.ElseBlock:
				return pm.spriteUtils.getConditionStatementSpriteName(this._value, state);
			case FunctionButton.Type.Expression:
				return pm.spriteUtils.getExprSpriteName(this._value, state);
			case FunctionButton.Type.HorizontalBar:
				return pm.spriteUtils.getEmptyMethodSpriteName(state);
		}
		return "";
	},

	_isEmpty: function()
	{
		switch (this._type)
		{
			case FunctionButton.Type.Repeater:
				return (this._value === pm.REPEATER_EMPTY);
			case FunctionButton.Type.Condition:
			case FunctionButton.Type.CondRepeater:
				return (this._value === pm.CONDITION_EMPTY);
			case FunctionButton.Type.Method:
			case FunctionButton.Type.Expression:
				return (this._value === pm.EMPTY_METHOD);
		}
	},

	_getBackgroundSprite: function()
	{
		switch (this._type)
		{
			case FunctionButton.Type.Repeater:
				return pm.spriteUtils.getRepeaterSprite("shadow");
			case FunctionButton.Type.Condition:
				return pm.spriteUtils.getRobotConditionSprite("shadow");
			case FunctionButton.Type.CondRepeater:
				return pm.spriteUtils.getRepeaterSprite("shadow");
			case FunctionButton.Type.Function:
			case FunctionButton.Type.Alloc:
			case FunctionButton.Type.Method:
				return pm.spriteUtils.getRobotMethodSprite("shadow");
			case FunctionButton.Type.Empty:
				return pm.spriteUtils.getEmptyMethodSpriteName();
			case FunctionButton.Type.Variable:
				return pm.spriteUtils.getRepeaterSprite("shadow");
			case FunctionButton.Type.Statement:
			case FunctionButton.Type.Number:
				return pm.spriteUtils.getRobotVariableSprite("shadow");
		}
	},

	switchPointsNumberR: function(iterNumber)
	{
		this.loadTextureNormal(this._getRSpriteName(pm.NORMAL_STATE, iterNumber), ccui.Widget.PLIST_TEXTURE);
		this.loadTexturePressed(this._getRSpriteName(pm.NORMAL_STATE, iterNumber), ccui.Widget.PLIST_TEXTURE);
		this.loadTextureDisabled(this._getRSpriteName(pm.NORMAL_STATE, iterNumber), ccui.Widget.PLIST_TEXTURE);
	},

	_getRSpriteName: function(state, iterNumber)
	{
		if(iterNumber === 0 || iterNumber === undefined)
			return pm.spriteUtils.getRepeaterSpriteName(this._value, state);

		return pm.spriteUtils.getRepeaterSpriteName("{0}_{1}".format(this._value, iterNumber), state);
	}
});

var _p = FunctionButtonK.prototype;

/** @expose */
_p.value;
cc.defineGetterSetter(_p, "value", _p.getValue, _p.setValue);

/** @expose */
_p.type;
cc.defineGetterSetter(_p, "type", _p.getType, _p.setType);
